export default __webpack_public_path__ + "static/media/guidelines-4.14f1b024.jpeg";